//Componentes generales
import React, { useState, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

//Tipos de Estado
import { ifState, ifStateBack } from "../../utils/states";
import { ifStateSolicitud} from "../../utils/states";

//Auth
import authContext from "../../context/authentication/authContex";

//Permisos
import { MODIFICA_COMPROBANTE_ESTADO_RECHAZADO } from "../../utils/permisos";

//Estilos
import "./StateChange.css";

// Alertas
import Swal from "sweetalert2";
import { useEffect } from "react";

/* 
    Componente de vista de dialogo de cambio de estado.
        Donde item es el comprobante a modificar el comprobante.
              guardarEstado es la función del context que guarda la modificación.
              cerrar es la función encargada de ocultar el dialogo.
*/
function StateChange({ item, codFor, nroFor, guardarEstado, cerrar }) {
  const { usuario } = useContext(authContext);
  const canModifyRechazado = usuario?.userType?.some((t) =>
    MODIFICA_COMPROBANTE_ESTADO_RECHAZADO.includes(t.typeName)
  ) ?? false;

  //state del comprobante.
  const [registro, setRegistro] = useState(item);
  //States para el dropdown
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const [disabledButton, setDisabledButton] = useState(false);

  const enabled = {
    cursor: "pointer",
  };

  const disabled = {
    cursor: "not-allowed",
    display: "none"
  };

  //State para check para mostrar estados anteriores
  // const [mostrarStatesAnt, setMostrarStatesAnt] = useState(false);
  //State para estados del comprobante
  const [opciones, setOpciones] = useState(registro.tDocCodFor ? ifState(item.state, canModifyRechazado) : ifStateSolicitud(item.state));

  /*     const handleCheckboxChange = () => {
        setMostrarStatesAnt(!mostrarStatesAnt);
        setOpciones(ifState(item.state));
      }; */

  /* 
        Función encargada de guardar la modificación del comprobante y lanzar una alerta.
            Donde r es el comprobante con el nuevo estado.
    */
  const save = async (r) => {
    try {
      setDisabledButton(true);
      const resp = await guardarEstado(r, r.state);

      // Si el handler bloqueó el cambio (ej: subcuenta vacía) retorna sin valor:
      // no mostramos éxito, solo cerramos. El aviso ya lo mostró el handler.
      if (!resp) {
        setDisabledButton(false);
        cerrar(null);
        return;
      }

      Swal.fire(
        "Nuevo Estado: " + r.state,
        resp.message != undefined
          ? "El Estado fue Modificado Correctamente <br> <strong>" +
              resp.message +
              " </strong> "
          : "El Estado fue Modificado Correctamente",
        "success"
      );
      setDisabledButton(false);
      cerrar(null);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error al modificar el estado",
        text: error.response?.data?.message || "Hubo un problema al intentar modificar el estado. Intenta nuevamente más tarde.",
      });
      console.error("Error al guardar el estado:", error);

      setDisabledButton(false);
      cerrar(null);
    }
  };

  return (
    <div className="container-gr-state">
      <div className="label-state-icon-r">
        <FontAwesomeIcon
          className="state-icon-r"
          icon={faXmark}
          onClick={() => cerrar(null)}
        />
      </div>
      <div className="container-state">
        <div className="label-state-data">
          <strong>
          {codFor +
            " - " +
            nroFor +
            " . Estado Actual: " +
            item.state}
            </strong>
        </div>
        <div className="container-state-list">
          <Dropdown
            isOpen={dropdownOpen}
            toggle={toggle}
            direction="down"
            className="dropdown-userTypes"
          >
            <DropdownToggle caret>
              {registro.state === "" ? "Seleccione un estado" : registro.state}
            </DropdownToggle>
            <DropdownMenu>
              {opciones.map(function (itemType, index) {
                return (
                  <article key={itemType}>
                    <DropdownItem
                      onClick={() => setRegistro({ ...registro, state: itemType })}
                    >
                      {itemType}
                    </DropdownItem>
                  </article>
                );
              })}
            </DropdownMenu>
          </Dropdown>
          {/*                 <div>
                    <label className='StateChange-div-item-check'>
                        <input type="checkbox" checked={mostrarStatesAnt} onChange={handleCheckboxChange} className='StateChange-list-item-check'></input>
                        <div>Mostrar estados anteriores</div>
                    </label>
                </div> */}
        </div>
        <div className="btn-state-container">
          <button
            className="btn-state"
            style={disabledButton ? disabled : enabled}
            disabled={disabledButton}
            onClick={() => save(registro)}
          >
            Cambiar Estado
          </button>
        </div>
      </div>
    </div>
  );
}

export default StateChange;